import { GridLegacy as Grid, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import { useState,useEffect, useContext } from "react";
import { AutoCompleteInputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext } from "../../store/AppStore";
import { AxiosInstance,  FormActions, FormatPrice, usuarioEntity } from "../../utils/constants";
import * as yup from "yup";
import { FilterForm } from "../../components/form/filter-form";


const schema = yup.object({
  cod_usuario: yup.string().required(),

  productos_asociados: yup.array().of(
    yup.object().shape({
      label:yup.string(),
      value:yup.number()
    })
  ).optional()
}).required();
const InitialFilterSearch = {
  rows_per_page:20,
  page_number:0,
  product_select:null,
  filter_search:""
};

const schemaFilter = yup.object({
  

}).required();

export const AgentesNecesidadesList = ()=>{

  const [dataSetProdctos,setDataSetProductos] = useState([]);
  const [filterSearchPagination,setFilterSearchPagination] = useState(InitialFilterSearch);
  const [totalRows,setTotalRows] = useState(0);
  const {dispatch,store} = useContext( AppContext );
  const [isVisibleModalDetalle,setIsVisibleModalDetalle] = useState(false);
  const [productoSeleccionado,setProductoSeleccionado] = useState({...usuarioEntity});
  const [tipoAction,setTipoAction] = useState(FormActions.AGREGAR);
  const [productosOptions,setProductosOptions] = useState([]);
  const [productFilterList,setProductFilterList] = useState([]);



    useEffect(()=>{

      
      loadInitData();

    },[]);
    

    useEffect(()=>{
  
      loadItems( filterSearchPagination.filter_search?false:true,filterSearchPagination );
    },[filterSearchPagination]);


    const loadInitData = async()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:true
      });
      await loadItems(false);
     
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    }


  const  setFilterAply = (filtros)=>{
    console.log({filtros});

    setFilterSearchPagination({
      ...filterSearchPagination,
      ...filtros
    });
  }

    const loadItems =  async (loading=true,filtros=filterSearchPagination)=>{
      console.log({filtros,filterSearchPagination});
      setDataSetProductos([]);
      if (loading){
        dispatch({
          type:ActionTypes.setLoadingPage,
          data:true
        });
      }

     let {data:{value}} = await AxiosInstance.post("maestros/get-necesidades-disponibles",{
      ...filtros,
      cod_producto:filtros.product_select?.value,
      page_number:filtros.page_number+1
     });
     setDataSetProductos([...value?.data]);

     setTotalRows(value?.total);
     dispatch({
      type:ActionTypes.setLoadingPage,
      data:false
    });
   
    }

    const handleChangePage = (event, newPage) => {
      
      setFilterSearchPagination({...filterSearchPagination,page_number:newPage});
    };

    const handleChangeRowsPerPage = (event) => {
      setFilterSearchPagination({...filterSearchPagination,rows_per_page:parseInt(event.target.value, 10)});
     
    };

  

    const onOpenModalItem = (edit=false)=>{
      if (!edit){
        setProductoSeleccionado({...usuarioEntity});
        setTipoAction(FormActions.AGREGAR);
      }
      setIsVisibleModalDetalle(true);
    }


    const searcProductoAsociado = async (event, newInputValue) => {
      try {
        let res = await onSearchProducto(newInputValue);
        setProductFilterList(res);
      } catch (e) {
  
      }
    }

    const onSearchProducto = async (value_search) => {

      if (value_search) {
         try{

          const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter", {
            search_query: value_search
          });
          return value;
         }catch(e){
          return [];
         }
  
      }
   }


  
    const columnsTable = [
      {
      
       key:"nombre_producto",
       keyValue:"nombre_producto",
       label:"Producto",
       headerRender:(props)=>props.label,
       bodyRender:(props)=>props.value,
       typeRow:"string",
       sort:false,
       sortFunction:()=>{},
       sortStatus:"", 

      },
     
      {
      
        key:"cantidad",
        keyValue:"cantidad",
        label:"Cantidad",
        headerRender:(props)=>props.label,
        bodyRender:({info,...props})=>`${FormatPrice(info.cantidad)} ${info.nombre_unidad_medida}`,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"nombre_municipio",
        keyValue:"nombre_municipio",
        label:"Destino",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
       {
      
        key:"fecha_entrega_acopio",
        keyValue:"fecha_entrega_acopio",
        label:"Fecha de entrega",
        headerRender:(props)=>props.label,
        bodyRender:(props)=>props.value,
        typeRow:"string",
        sort:false,
        sortFunction:()=>{},
        sortStatus:"", 
 
       },
 
    ];
   




    const InputFilters = [
      {
        grid:{
          xs:3,
          md:3,
          sm:3
        },
        InputComponent:AutoCompleteInputWithLabel,
        keyValue:"product_select",
        InputComponentProps:{
          label:"Producto",
          fullWidth: true,
          isLoading: false,
          multiple:false,
          size:'small',
      /*     PopperComponent:(props)=><div hidden={!props.open} >
           
             {props.children}
          </div>, */
          onInputChange: searcProductoAsociado,
          options: productFilterList || [],
          noOptionsText: "Lista vacia",
          getOptionLabel: (option) => option.label,
          isOptionEqualToValue: (option, value) => option.value === value.value,
          filterOptions:(x) => x,
        }
      },
      ];

    return (<>
   
   
    <Grid container spacing={2} >
        <Grid item sm={12} xs={12} md={10} >

      
          <FilterForm
            buttomDist={
              {
                sx:10,
                md:5
              }
            }
            nameFilter={"Buscar necesidades por"}
            inputsFilter={InputFilters}
            schemaValidator={schemaFilter}
            initialValuesFilter={
            {  product_select:filterSearchPagination?.producto,
            
             }
            }
            onApplyFilter={setFilterAply}
          />
       
        

        </Grid>
       
        <Grid item sm={12} xs={12} md={12} >

          <TableContainer>
               <Table>
            <TableHead>
              <TableRow>

                {
                  columnsTable.map(colum => <TableCell key={colum.key} >
                    {<colum.headerRender label={colum.label} />}
                  </TableCell>)
                }

              </TableRow>

            </TableHead>
            <TableBody>
              
                 {dataSetProdctos.map( prod=>
                  <TableRow key={prod.cod_index_prod}  >

                    {
                      columnsTable.map(Col=>
                        <TableCell  >
                          {<Col.bodyRender info={prod} value={prod[Col.keyValue]} />}
                       </TableCell>)
                    }

                  </TableRow>
                )}
              
            </TableBody>
           
          </Table>
          </TableContainer>
          <TablePagination
          rowsPerPageOptions={[20, 40, 60]}
          component="div"
          count={totalRows}
          rowsPerPage={filterSearchPagination.rows_per_page}
          page={filterSearchPagination.page_number}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        </Grid>
    </Grid>
    </>)

}